const defaultState = {
  isFetching: false,
  isAuthenticated: false,
  user: null,
  token: null,
  refreshToken: null,
  sessionExpireDialog: false,
  tokenExpirationLastCheck: null,
  tokenExpirationIntervalId: null,
  tokenRefreshing: false,
  isSwitchingRoles: false,
  switchingRolesError: null,
  logoutBlockers: [],
};

export const SET_IS_SWITCHING_ROLES = 'SET_IS_SWITCHING_ROLES';
export const SET_SWITCHING_ROLES_ERROR = 'SET_SWITCHING_ROLES_ERROR';

function login(state = defaultState, action) {
  switch (action.type) {
    case 'CLEAR_STATE':
      return defaultState;
    case 'LOGIN_REQUEST':
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case 'CLEAR_FETCHING_STATUS':
      return { ...state, isFetching: false };
    case 'LOGIN_SUCCESS':
      return {
        ...state,
        isFetching: false,
        isAuthenticated: true,
        user: action.user,
        token: action.token,
        isSwitchingRoles: false,
        switchingRolesError: null,
      };
    case 'LOGIN_ERROR':
      return {
        ...state,
        error: action.error,
        isFetching: false,
        switchingRolesError: null,
      };
    case 'LOGOUT':
      return {
        ...state,
        isAuthenticated: false,
        token: null,
        sessionExpireDialog: false,
        refreshToken: null,
        isSwitchingRoles: false,
        switchingRolesError: null,
      };
    case 'SESSION_EXPIRE_DIALOG':
      return { ...state, sessionExpireDialog: true };
    case 'CLOSE_SESSION_EXPIRE_DIALOG':
      return { ...state, sessionExpireDialog: false };
    case 'SET_REFRESH_TOKEN':
      return { ...state, refreshToken: action.refreshToken };
    case 'REMOVE_REFRESH_TOKEN':
      return { ...state, refreshToken: null };
    case 'SET_TOKEN_EXPIRATION_INTERVAL_ID':
      return { ...state, tokenExpirationIntervalId: action.id };
    case 'TOKEN_EXPIRATION_CHECK':
      return { ...state, tokenExpirationLastCheck: action.timestamp };
    case 'CLEAR_TOKEN_REFRESH_TIMEOUT':
      return { ...state, tokenExpirationLastCheck: null };
    case 'REFRESH_TOKEN_REQUEST':
      return { ...state, tokenRefreshing: true };
    case 'REFRESH_TOKEN_REQUEST_SUCCESS':
    case 'REFRESH_TOKEN_REQUEST_ERROR':
      return { ...state, tokenRefreshing: false };
    case SET_IS_SWITCHING_ROLES:
      return { ...state, isSwitchingRoles: action.payload };
    case 'INIT_CONFIG':
      return {
        ...state,
        isSwitchingRoles: false,
        switchingRolesError: null,
      };
    case SET_SWITCHING_ROLES_ERROR:
      return { ...state, switchingRolesError: action.error };
    case 'ADD_LOGOUT_BLOCKER':
      return { ...state, logoutBlockers: [...state.logoutBlockers, action.blocker] };
    case 'REMOVE_LOGOUT_BLOCKER':
      return { ...state, logoutBlockers: state.logoutBlockers.filter(blocker => blocker !== action.blocker) };

    default:
      return state;
  }
}

export default login;
